import { Layout, Modal } from "antd"
import MapsFullScreen from "../../../component/maps/MapsFullScreen"
import { MapsIcon } from "../../../asset"
import { useLocation } from "react-router-dom"
import Geocode from "react-geocode";
import { useState } from "react";

const MapsCustomer = (props)=>{
  let location = useLocation()
  const [loc, setLoc] = useState()
  console.log("loccust", location);
  // const geocode = () => {
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    Geocode.fromLatLng(location?.state?.latitude,location?.state?.longitude).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        setLoc(response.results[0].formatted_address)
        console.log("res", response.results[0].formatted_address);
      },
      (error) => {
        console.error("geo eroer", error);
      }
    );
  // };
  return(
    <>
    <Modal
        visible={props.show}
        closable={false}
        centered={true}
        width="full"
        footer={null}
      >
    <Layout.Header
        style={{
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          zIndex: 1,
          boxShadow: "0px 4px 12px -4px rgba(0, 0, 0, 0.15)",
          height:"90px"
        }}
      >
        <div className="mt-6 flex">
          <img className="h-10" src={MapsIcon} alt="map"/>
          <div>
            <div className="text-red-100 mt-[-6px] font-bold ml-2 text-xl">Bojong Nangka</div>
            <div className="text-red-100 mt-[-20px] font-semibold ml-2">{loc}</div>
          </div>
        </div>
      </Layout.Header>
      <div >
      <MapsFullScreen
          lat={location?.state?.latitude}
          long={location?.state?.longitude}/>
      </div>
      </Modal>
    </>
  )
}
export default MapsCustomer